import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManualReportPage } from './manual-report.page';

const routes: Routes = [
  {
    path: '',
    component: ManualReportPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManualReportPageRoutingModule {}
